import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux'
import { useParams } from 'react-router-dom';
import { bucket_url } from '../../constants/const'
import Loading from '../../components/layouts/Loading'
import Error404 from '../../components/Error/Error404'
import { Button, Carousel, Col, Container, Image, Row } from 'react-bootstrap';
import PublicationCard from '../../components/publicationCard/publicationCard.component';
import PublicationInfoCard from './publicationInfoCard';

import './publicationDetailsPage.css';
import PublicationImageCarousel from '../../components/publicationImageCarousel/publicationImageCarousel';
import { LinkContainer } from 'react-router-bootstrap';

const PublicationDetailsPage = props => {

    const { loading, publications } = useSelector(state => state.all)

    const { id } = useParams()

    const [singlePublication, setSinglePublication] = useState(null)

    const [similarCategory, setSimilarCategory] = useState([])

    useEffect(() => {
        if (singlePublication && publications.length > 0) {
            let list = []
            publications.map((item, index) => {
                item.categories.map(cat => {
                    singlePublication.categories.map(i => {
                        if (i.name === cat.name && singlePublication._id !== item._id) {
                            list.push(item)
                        }
                    })
                })

            })
            setSimilarCategory(list)
        }
    }, [singlePublication])

    useEffect(() => {
        if (publications.length > 0) {
            setSinglePublication(publications.find(item => item._id === id))
        }
    }, [publications, id])

    return (
        loading ? <Loading /> :
            <section className="publication-details-page py-5">
                {singlePublication ? (
                    <Container>
                        <Row className="mt-0 mt-lg-2 mb-0 mb-md-3 mb-xl-5">
                            <Col className="mb-3 mb-md-4 mb-lg-0" xs={{ order: 1, span: 12 }} md={{ order: 1, span: 6 }}>
                                <PublicationImageCarousel publication={singlePublication} />
                            </Col>
                            <Col xs={{ order: 2, span: 12 }} md={{ order: 2, span: 6 }}>
                                <PublicationInfoCard />
                            </Col>
                        </Row>
                        {
                            !!singlePublication?.details &&
                            <Row>
                                <Col xs={12}>
                                    <hr className='mb-5 mt-0' />
                                    <div dangerouslySetInnerHTML={{ __html: singlePublication.details }}></div>
                                </Col>
                            </Row>
                        }
                        {
                            (similarCategory && similarCategory.length > 0) &&
                            <>
                                <hr className='my-5' />
                                <Row className='justify-content-center'>
                                    <Col xs={12}>
                                        <h5 className="text-center font-weight-bold mb-4 mb-md-5 mt-3">অনুরূপ প্রকাশনাসমূহঃ </h5>
                                    </Col>
                                    {similarCategory.map((item, index) => {
                                        if (index < 4) {
                                            return <Col xs={6} md={4} lg={3} key={index} className="mb-4">
                                                <PublicationCard item={item} />
                                            </Col>
                                        }
                                        return null
                                    })}
                                </Row>
                            </>
                        }
                    </Container>
                ) : <Error404 />}
            </section>
    )
}


export default PublicationDetailsPage;